<template>
  <div>
    <img :alt="file.name" :src="file.path" srcset="" />
  </div>
</template>

<script>
export default {
  props: { file: { required: true } },
  data: () => ({}),
  computed: {},
  methods: {},
}
</script>

<style scoped></style>
